import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import IndentedCardHeader from '../../IndentedCardHeader/IndentedCardHeader.js';
import IndentedCardContent from '../../IndentedCardContent/IndentedCardContent.js';
import ActionButton from '../../../components/ActionButton/ActionButton';
import DocumentStyleArea from '../../../components/DocumentStyleArea/DocumentStyleArea';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class MessageCard extends React.Component {
  state = {
    expanded: this.props.collapsable && this.props.initialExpand,
  };

  constructor(props) {
    super(props);

    this.onToggle = this.onToggle.bind(this);
  }

  onToggle(e) {
    const { additionalAction } = this.props;
    this.setState({ expanded: !this.state.expanded });
    if (additionalAction) {
      additionalAction();
    }
    e.stopPropagation();
  }

  render() {
    const {
      classes,
      title,
      body,
      type,
      isHTML,
      icon,
      collapsable,
    } = this.props;
    const { expanded } = this.state;

    const ActionIcon = expanded ? ExpandLessIcon : ExpandMoreIcon;

    return (
      <div className={classes.root}>
        <Card
          className={`Card ${
            type === 'outage' ? classes.outageCard : classes.messageCard
          }`}
        >
          <IndentedCardHeader
            title={
              <Typography variant='h3' component='h2'>
                {title}
              </Typography>
            }
            avatar={icon}
            action={
              collapsable ? (
                <ActionButton
                  action={this.onToggle}
                  icon={ActionIcon}
                  label={expanded ? 'Collapse' : 'Expand'}
                  small={true}
                />
              ) : null
            }
            actionHeader={collapsable ? this.onToggle : null}
            classes={{
              root:
                expanded || !collapsable
                  ? classes.headerExpanded
                  : classes.headerCollapsed,
              title: classes.title,
              avatar: type === 'outage' ? classes.outage : classes.message,
            }}
          />
          <Collapse in={collapsable ? expanded : true} unmountOnExit>
            <IndentedCardContent
              body={
                <div className={classes.negativeTopMargin}>
                  <Divider
                    className={collapsable ? classes.dividerExpanded : ''}
                  />
                  <div className={classes.contentContainer}>
                    <DocumentStyleArea content={body} />
                  </div>
                </div>
              }
            />
          </Collapse>
        </Card>
      </div>
    );
  }
}

MessageCard.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  type: PropTypes.string,
  isHTML: PropTypes.bool,
  icon: PropTypes.object.isRequired,
  collapsable: PropTypes.bool,
  initialExpand: PropTypes.bool,
  additionalAction: PropTypes.func,
};

MessageCard.defaultProps = {
  type: 'outage',
  isHTML: false,
  collapsable: false,
  initialExpand: false,
};

export default withStyles(styles)(MessageCard);
